import {
  DRIFT_CHAT_END_USERS_DIMENSIONS,
  DRIFT_SITE_CONCIERGE_SEARCH_MEASURES,
  DRIFT_SITE_CONCIERGE_SEARCH_MESSAGES_DIMENSIONS,
  DRIFT_SITE_CONCIERGE_SEARCH_MESSAGES_MEASURES,
} from 'cube/constants'

import type { CubeQuery } from '@driftt/dds.reports'

export const SiteConciergeSearchQuery: CubeQuery = {
  name: 'SiteConciergeSearchQuery',
  queryName: 'SiteConciergeSearchQuery',
  query: {
    measures: [
      DRIFT_SITE_CONCIERGE_SEARCH_MEASURES.COUNT_LOADS,
      DRIFT_SITE_CONCIERGE_SEARCH_MEASURES.COUNT_SEARCHES_PERFORMED,
      DRIFT_SITE_CONCIERGE_SEARCH_MEASURES.COUNT_SEARCH_BUTTON_CLICKS,
      DRIFT_SITE_CONCIERGE_SEARCH_MEASURES.COUNT_SOURCE_CLICK_THROUGHS,
    ],
  },
}

export const SiteConciergeSearchTableQuery: CubeQuery = {
  name: 'SiteConciergeSearchTable',
  queryName: 'SiteConciergeSearchTable',
  query: {
    dimensions: [
      DRIFT_SITE_CONCIERGE_SEARCH_MESSAGES_DIMENSIONS.PROMPT,
      DRIFT_SITE_CONCIERGE_SEARCH_MESSAGES_DIMENSIONS.RESPONSE,
      DRIFT_SITE_CONCIERGE_SEARCH_MESSAGES_DIMENSIONS.RATING,
      DRIFT_SITE_CONCIERGE_SEARCH_MESSAGES_DIMENSIONS.SOURCE_REGIONS,
      DRIFT_SITE_CONCIERGE_SEARCH_MESSAGES_DIMENSIONS.SESSION_ID,
      DRIFT_SITE_CONCIERGE_SEARCH_MESSAGES_DIMENSIONS.IS_GENERATED_QUESTION,
      DRIFT_SITE_CONCIERGE_SEARCH_MESSAGES_DIMENSIONS.MESSAGE_ID,
      DRIFT_SITE_CONCIERGE_SEARCH_MESSAGES_DIMENSIONS.LANGUAGE,
      DRIFT_CHAT_END_USERS_DIMENSIONS.DISPLAY_NAME,
      DRIFT_CHAT_END_USERS_DIMENSIONS.COMPANY_NAME,
      DRIFT_SITE_CONCIERGE_SEARCH_MESSAGES_DIMENSIONS.EVENT_CREATED_AT_WITH_ZONE,
    ],
  },
}

export const SiteConciergeSearchMessagesCountQuery: CubeQuery = {
  name: 'SiteConciergeSearchMessagesCount',
  query: {
    measures: [DRIFT_SITE_CONCIERGE_SEARCH_MESSAGES_MEASURES.COUNT],
  },
}
